<template>
  <div></div>
</template>

<script>
export default {
name:"Loading"
}
</script>

<style>

</style>